import React, { FC } from 'react';
import translate from '@translate';
import Grid, { GridItem } from 'src/components/Grid';
import TextField from 'src/components/TextField';
import Select from 'src/components/Select';
import { TransportPackageType } from 'src/types/transportPackageType';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import { FormErrorsType, OnChangeType } from 'src/types/global';
import { EditKeysType } from './constants';

export interface DetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: TransportPackageType;
    editErrors: FormErrorsType;
    newItem: boolean;
    disableEdit: boolean;
    boolNumberCodes: ConstantsCodeType[];
    geisPackingTypeCodes: ConstantsCodeType[];
}

const Detail: FC<DetailPropsType> = (props) => {
    const hasCatalogue = Boolean(props.editData.BILLING_GROUP || props.editData.NAME_CS || props.editData.SYNCED_AT);

    return (
        <Grid>
            <GridItem cols={6}>
                <TextField
                    value={props.editData.SSRC_CODE}
                    error={props.editErrors.SSRC_CODE}
                    onChange={(value, error) => props.onChange('SSRC_CODE', value, error)}
                    name="SSRC_CODE"
                    label={translate('transportPackageTypeDetail.ssrcCode')}
                    fullWidth
                    required
                    disabled={!props.newItem || props.disableEdit}
                />
            </GridItem>
            <GridItem cols={6}>
                <TextField
                    value={props.editData.NAME}
                    error={props.editErrors.NAME}
                    onChange={(value, error) => props.onChange('NAME', value, error)}
                    name="NAME"
                    label={translate('transportPackageTypeDetail.name')}
                    fullWidth
                    required
                    disabled={props.disableEdit || hasCatalogue}
                />
            </GridItem>
            <GridItem cols={6}>
                <Select
                    options={[{ label: '—', value: '' }, ...props.geisPackingTypeCodes]}
                    value={props.editData.GEIS_PACKING_TYPE_CODE ?? ''}
                    error={props.editErrors.GEIS_PACKING_TYPE_CODE}
                    onChange={(value, error) =>
                        props.onChange('GEIS_PACKING_TYPE_CODE', value ? String(value) : null, error)
                    }
                    name="GEIS_PACKING_TYPE_CODE"
                    label={translate('transportPackageTypeDetail.geisCode')}
                    fullWidth
                    disabled={props.disableEdit}
                    virtualized
                    helperText={
                        props.geisPackingTypeCodes.length === 0
                            ? translate('geisPackingTypes.message.emptyHint')
                            : undefined
                    }
                />            </GridItem>
            <GridItem cols={6}>
                <TextField
                    value={props.editData.TYPE ?? ''}
                    error={props.editErrors.TYPE}
                    onChange={(value, error) => props.onChange('TYPE', value || null, error)}
                    name="TYPE"
                    label={translate('transportPackageTypeDetail.type')}
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={6}>
                <TextField
                    value={props.editData.SORT_ORDER}
                    error={props.editErrors.SORT_ORDER}
                    onChange={(value, error) => props.onChange('SORT_ORDER', value, error)}
                    name="SORT_ORDER"
                    label={translate('transportPackageTypeDetail.sortOrder')}
                    fullWidth
                    type="numberLocale"
                    min={0}
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={6}>
                <Select
                    options={props.boolNumberCodes}
                    value={props.editData.ACTIVE === undefined ? 1 : props.editData.ACTIVE}
                    error={props.editErrors.ACTIVE}
                    onChange={(value, error) => props.onChange('ACTIVE', Number(value), error)}
                    name="ACTIVE"
                    label={translate('transportPackageTypeDetail.active')}
                    fullWidth
                    disabled={props.disableEdit || props.newItem}
                />
            </GridItem>
            {(props.editData.NAME_CS || props.editData.NAME_EN) && (
                <>
                    <GridItem cols={6}>
                        <TextField
                            value={props.editData.NAME_CS ?? ''}
                            name="NAME_CS"
                            label={translate('transportPackageTypeDetail.nameCs')}
                            fullWidth
                            disabled
                        />
                    </GridItem>
                    <GridItem cols={6}>
                        <TextField
                            value={props.editData.NAME_EN ?? ''}
                            name="NAME_EN"
                            label={translate('transportPackageTypeDetail.nameEn')}
                            fullWidth
                            disabled
                        />
                    </GridItem>
                </>
            )}
            {(props.editData.UNIT_CS || props.editData.TYPE_CS || props.editData.BILLING_GROUP) && (
                <>
                    <GridItem cols={6}>
                        <TextField
                            value={props.editData.BILLING_GROUP ?? ''}
                            name="BILLING_GROUP"
                            label={translate('transportPackageTypeDetail.billingGroup')}
                            fullWidth
                            disabled
                        />
                    </GridItem>
                    <GridItem cols={6}>
                        <TextField
                            value={props.editData.TYPE_CS ?? ''}
                            name="TYPE_CS"
                            label={translate('transportPackageTypeDetail.typeCs')}
                            fullWidth
                            disabled
                        />
                    </GridItem>
                    <GridItem cols={6}>
                        <TextField
                            value={props.editData.UNIT_CS ?? ''}
                            name="UNIT_CS"
                            label={translate('transportPackageTypeDetail.unitCs')}
                            fullWidth
                            disabled
                        />
                    </GridItem>
                </>
            )}
        </Grid>
    );
};

export default Detail;
